import util from '../util'

let controller = 'RepasseSaldoContaTransacional'
export default Object.assign({}, util.GetCrud(controller, ['get', 'post', 'put', 'persist']), {
    GetAll: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller, dto)
    },
    ObterCodigosContaCredito: function (id) {
        return util.Axios.Get(controller + '/ContasCredito', id)
    }
})